/**
 * @generated SignedSource<<cfdcbbf4a6278a8abed0dc3881d28695>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetUserTutorialViewedInput = {
  clientMutationId?: string | null | undefined;
};
export type useSetUserTutorialViewedMutation$variables = {
  input: SetUserTutorialViewedInput;
};
export type useSetUserTutorialViewedMutation$data = {
  readonly setUserTutorialViewed: {
    readonly clientMutationId: string | null | undefined;
    readonly user: {
      readonly tutorialViewedAt: any | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserTutorialViewedMutation = {
  response: useSetUserTutorialViewedMutation$data;
  variables: useSetUserTutorialViewedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialViewedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserTutorialViewedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserTutorialViewedPayload",
        "kind": "LinkedField",
        "name": "setUserTutorialViewed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserTutorialViewedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserTutorialViewedPayload",
        "kind": "LinkedField",
        "name": "setUserTutorialViewed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e38e12b175c6e671d1e17d165a909d8d",
    "id": null,
    "metadata": {},
    "name": "useSetUserTutorialViewedMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserTutorialViewedMutation(\n  $input: SetUserTutorialViewedInput!\n) {\n  setUserTutorialViewed(input: $input) {\n    clientMutationId\n    user {\n      tutorialViewedAt\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "35d8a244951feb832faf01b4fb2f2d86";

export default node;
